"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onEnterKey = void 0;
var ENTER_KEY = 'Enter';
var ENTER_KEY_CODE = 13;
var onEnterKey = exports.onEnterKey = function onEnterKey(callback) {
  return function (event) {
    if (
    // eslint-disable-next-line react/destructuring-assignment
    (event.key === ENTER_KEY || event.keyCode === ENTER_KEY_CODE) && callback) {
      // eslint-disable-next-line react/destructuring-assignment
      event.preventDefault();
      callback(event);
    }
    return null;
  };
};
//# sourceMappingURL=events.js.map